import MyButton from './MyButton';

export default MyButton;
